import requestWrapper from '../../requestWrapper';
import endpoints from './endpoints';
import type {ContentType} from '@deezer/next/services/types/contentType';
import type {SearchAllResult, SearchResult} from './types';
import type {DataResponseWrapper} from '@deezer/next/services/api/Starmania/requests/types';

const {get} = requestWrapper;

const requests = {
	searchAll: (
		queryString: string,
		searchType: string,
		requestId: string,
		params?: object,
	) =>
		get<SearchAllResult>(endpoints.searchAll, {
			requestId,
			params: {
				...params,
				q: queryString,
				type: searchType || undefined,
			},
		}),
	searchItem: <T extends ContentType>(
		contentType: T,
		queryString: string,
		requestId: string,
		params?: object,
	) => {
		return get<DataResponseWrapper<SearchResult<T>>>(
			endpoints.searchItem(contentType),
			{
				requestId,
				params: {
					...params,
					q: queryString,
				},
			},
		);
	},
};

export default requests;
